import {
  REMOVE_LIST_ITEM,
  REMOVE_LIST_ITEM_SUCCEEDED,
  REMOVE_LIST_ITEM_FAILED,
} from "../types"

export const removeList = config => {
  return { type: REMOVE_LIST_ITEM, config }
}

export const removeListSuccess = (action, response) => {
  return {
    type: REMOVE_LIST_ITEM_SUCCEEDED,
    action,
    response,
    config: action.config,
  }
}

export const removeListError = (action, error) => {
  return { type: REMOVE_LIST_ITEM_FAILED, action, error }
}
